/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { LocaleMessages } from "@epic-mw/i18n";

interface Props {
	messages?: LocaleMessages;
	structuredData?: {
		website?: string;
		organization?: string;
	};
}

export const FavIcons = ({ messages = {}, structuredData }: Props): React.JSX.Element => {
	const title = messages["epic.app.meta.title"];

	return (
		<>
			<link rel="icon" type="image/svg+xml" href="/cosmos/static/favicons/favicon.svg" />
			<link rel="icon" type="image/png" href="/cosmos/static/favicons/favicon-96x96.png" sizes="96x96" />
			<link rel="apple-touch-icon" sizes="180x180" href="/cosmos/static/favicons/apple-touch-icon.png" />
			<link rel="manifest" href="/cosmos/static/favicons/site.webmanifest" />
			<meta name="apple-mobile-web-app-title" content={title} />
			<meta name="application-name" content={title} />
			<meta name="msapplication-TileColor" content="#26bbff" />
			<meta name="theme-color" content="#ffffff" />
			<link rel="alternate" type="application/rss+xml" title={title} href="/rss" />
			{structuredData && structuredData.website ? (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: structuredData.website,
					}}
				/>
			) : null}
			{structuredData && structuredData.organization ? (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: structuredData.organization,
					}}
				/>
			) : null}
		</>
	);
};
